var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-layout',[_c('AdminMenu'),_vm._v(" "),_c('v-container',[_c('v-layout',{staticClass:"pt-4",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h5',[_vm._v("Alcohol History")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f0f747","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/NongTungJai/AlcoholHistory.vue
// module id = null
// module chunks = 